import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/addresses/page.tsx");
